import { render, staticRenderFns } from "./SpiSubscription.vue?vue&type=template&id=288204c1&scoped=true"
import script from "./SpiSubscription.vue?vue&type=script&lang=js"
export * from "./SpiSubscription.vue?vue&type=script&lang=js"
import style0 from "./SpiSubscription.vue?vue&type=style&index=0&id=288204c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288204c1",
  null
  
)

export default component.exports